var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotte13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#F4EFFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480.606 63.1739C544.511 59.902 564.912 104.122 665.725 85.7497C746.112 71.1018 780.719 125.792 790.73 159.769C795.507 176.002 796.721 239.451 752.609 240.357C602.906 243.478 482.957 407.926 410.785 264.116C381.512 205.776 335.529 70.6236 480.606 63.1739Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.657 340C230.448 371.411 258.309 406.556 292.956 406.792C327.616 407.028 355.948 372.276 356.156 340.851C356.365 309.44 328.386 293.249 293.726 293.013C259.066 292.778 230.865 308.575 230.644 339.987L230.657 340Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.162 348.992L250.172 348.985C256.24 344.948 257.898 336.738 253.876 330.648L228.849 292.751C224.827 286.661 216.648 284.996 210.581 289.033L210.57 289.041C204.503 293.078 202.845 301.288 206.867 307.378L231.893 345.275C235.915 351.365 244.094 353.029 250.162 348.992Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.865 292.616L376.854 292.608C370.985 288.287 362.736 289.559 358.431 295.451L331.641 332.113C327.336 338.005 328.604 346.284 334.473 350.606L334.484 350.614C340.353 354.935 348.602 353.662 352.907 347.771L379.697 311.109C384.003 305.217 382.734 296.937 376.865 292.616Z",
    fill: "url(#paint2_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.952 220.773L236.033 207.988C229.639 204.071 221.6 204.045 215.18 207.922C204.335 214.446 196.179 224.65 192.186 236.675C185.557 256.625 194.43 278.435 213.065 288.023L233.788 298.686L256.939 220.759L256.952 220.773Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.037 232.601L235.641 221.977C230.317 218.729 223.635 218.703 218.298 221.925C209.294 227.348 202.508 235.836 199.193 245.831C193.686 262.414 201.059 280.543 216.562 288.521L233.788 297.389L253.037 232.601Z",
    fill: "url(#paint3_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.639 220.773L350.557 207.988C356.952 204.071 364.991 204.045 371.411 207.922C382.242 214.446 390.398 224.65 394.392 236.675C401.021 256.625 392.147 278.435 373.512 288.023L352.789 298.686L329.639 220.759V220.773Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.554 232.601L350.949 221.977C356.273 218.729 362.955 218.703 368.292 221.925C377.297 227.348 384.082 235.836 387.397 245.831C392.904 262.414 385.531 280.543 370.028 288.521L352.802 297.389L333.554 232.601Z",
    fill: "url(#paint4_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.111 282.678C363.111 321.386 331.857 338.743 293.295 338.743C254.733 338.743 223.479 321.386 223.479 282.678C223.479 243.971 266.517 202.407 293.295 202.407C320.073 202.407 363.111 243.971 363.111 282.678Z",
    fill: "url(#paint5_linear_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.432 207.411C284.591 212.153 284.696 225.96 284.696 225.96C284.839 226.431 285.505 226.274 285.727 226.13C286.679 225.514 288.872 222.829 288.872 222.829C289.146 222.436 289.733 222.528 289.89 222.973C289.89 222.973 291.338 227.977 291.664 232.47C291.691 232.758 292.552 232.601 292.774 232.444C294.849 230.937 296.597 222.672 296.597 222.672C296.728 222.213 297.302 222.095 297.602 222.449C297.602 222.449 299.951 223.523 301.178 226.746C301.269 226.994 302 226.667 302.196 226.484C306.097 222.894 308.473 209.298 305.549 205.067C301.4 199.054 272.716 202.997 278.432 207.398V207.411Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.515 292.621C274.686 292.621 283.742 280.892 283.742 266.423C283.742 251.954 274.686 240.225 263.515 240.225C252.344 240.225 243.288 251.954 243.288 266.423C243.288 280.892 252.344 292.621 263.515 292.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.857 266.423C339.857 271.335 336.999 278.553 336.999 278.553L308.681 286.792C308.681 286.792 299.547 278.932 299.416 266.423C299.259 251.948 308.473 240.225 319.643 240.225C330.814 240.225 339.87 251.948 339.87 266.423H339.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.871 264.379C277.871 259.315 273.781 255.21 268.736 255.21C263.691 255.21 259.602 259.315 259.602 264.379V273.549C259.602 278.613 263.691 282.718 268.736 282.718C273.781 282.718 277.871 278.613 277.871 273.549V264.379Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.778 268.309C269.301 268.309 271.346 266.256 271.346 263.724C271.346 261.192 269.301 259.14 266.778 259.14C264.256 259.14 262.211 261.192 262.211 263.724C262.211 266.256 264.256 268.309 266.778 268.309Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.545 264.379C323.545 259.315 319.455 255.21 314.41 255.21C309.365 255.21 305.275 259.315 305.275 264.379V273.549C305.275 278.613 309.365 282.718 314.41 282.718C319.455 282.718 323.545 278.613 323.545 273.549V264.379Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.452 268.309C314.975 268.309 317.02 266.256 317.02 263.724C317.02 261.192 314.975 259.14 312.452 259.14C309.93 259.14 307.885 261.192 307.885 263.724C307.885 266.256 309.93 268.309 312.452 268.309Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.112 314.588L346.512 303.703C347.987 303.1 348.313 300.978 347.152 299.563C343.941 295.607 337.56 289.543 330.813 293.119C324.837 296.289 319.891 304.751 316.994 310.698C315.976 312.807 318.077 315.426 320.112 314.601V314.588Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.693 375.276C283.468 375.486 285.987 377.294 287.266 377.215C289.419 377.097 288.349 373.639 288.375 373.089C288.897 365.242 293.83 349.825 296.87 343.459C301.412 333.936 308.419 320.627 309.737 313.789C312.047 301.79 305.3 292.962 295.735 289.752C286.169 286.543 274.803 291.442 270.144 300.494C265.486 309.519 268.983 331.316 271.541 341.114C274.268 351.606 275.873 367.941 273.981 373.442C273.785 374.006 273.811 376.062 276.043 376.429C277.805 376.717 279.318 374.988 281.706 375.276H281.693Z",
    fill: "url(#paint6_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M-141.394 -87.8261C-77.4885 -91.098 -57.0883 -46.8776 43.7247 -65.2503C124.112 -79.8982 158.719 -25.2079 168.73 8.76903C173.507 25.0025 174.721 88.4512 130.609 89.3573C-19.0939 92.4781 -139.043 256.926 -211.215 113.116C-240.488 54.7763 -286.471 -80.3764 -141.394 -87.8261Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 23,
    width: 370,
    height: 140,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261 188L234 163H256.909L261 188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 222.644,
    y: 288.011,
    width: 141.514,
    height: 129.782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 215.479,
    y: 197.407,
    width: 155.633,
    height: 152.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 275.682,
    y: 201,
    width: 33.1709,
    height: 34.6309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 259.859,
    y: 283.767,
    width: 58.334,
    height: 104.451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 78,
    y: 8,
    width: 430,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 293.422,
    y1: 293.01,
    x2: 293.42,
    y2: 406.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 198.295,
    y1: 322.878,
    x2: 153.8,
    y2: 325.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 390.775,
    y1: 327.546,
    x2: 435.073,
    y2: 332.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 253.024,
    y1: 258.458,
    x2: 197.379,
    y2: 258.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 333.554,
    y1: 258.458,
    x2: 389.211,
    y2: 258.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 293.295,
    y1: 338.743,
    x2: 293.295,
    y2: 202.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 290.479,
    y1: 288.798,
    x2: 284.61,
    y2: 377.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotte13);
export default __webpack_public_path__ + "static/media/mascotte13.23875bca4c34754875318734aebba63e.svg";
export { ForwardRef as ReactComponent };